module.exports = __webpack_public_path__ + "img/20200513_151928.2dde719b.jpg";